// ** Redux
import { createAsyncThunk } from "@reduxjs/toolkit";

// ** Helpers
import { createApiCall } from "helpers/createApiCall";

// ** Config
import { API_REACT_URL_FROM_CLIENT, API_REACT_URL_FROM_SERVER } from "config";

// ############################################################

export const getUsersSeoContent = createAsyncThunk(
	"mainPages/users/getUsersSeoContent",
	createApiCall(async ({ fileName }) => {
		const isSSR = typeof window === "undefined";

		const apiUrl = isSSR
			? API_REACT_URL_FROM_SERVER
			: API_REACT_URL_FROM_CLIENT;

		const response = await fetch(
			`${apiUrl}/api/json/content?file=${fileName}`
		);

		const jsonResponse = await response.json();
		return jsonResponse;
	})
);

// ############################################################
